import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { Flex } from 'rebass';
import styled from 'styled-components';

import IconButton from '@/components/Button/IconButton';

import CheckTask from '../Icon/CheckTask';
import CloseTask from '../Icon/CloseTask';

const MyTextareaAutosize = styled(TextareaAutosize)`
  font-family: Plus Jakarta Sans;
  color: #333333;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 0.422rem;
  padding-right: 0.422rem;
  padding-top: 0.422rem;
  padding-bottom: 0.422rem;
  border-color: transparent;
  min-width: 100%;
  max-width: 100%;
  min-height: auto !important;
  resize: none;
  &:hover {
    border-color: #ebebeb;
  }
  &:focus,
  &:active,
  &:visited {
    outline: none;
    -webkit-appearance: none;
  }
  &:focus-visible {
    outline: none;
    border-color: #333333;
  }
`;
export default function DefaultTextarea({ initalValue, handleChangeInput, ...props }) {
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState(initalValue);

  const handleFocus = () => {
    setFocused(true);
  };

  const handleReset = () => {
    setValue(initalValue);
    setFocused(false);
  };

  const handleSave = () => {
    handleChangeInput(value);
    setFocused(false);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    setValue(initalValue);
  }, [initalValue]);

  return (
    <Flex flexDirection="column" width={['100%']}>
      <div>
        <MyTextareaAutosize
          {...props}
          onChange={handleChange}
          onBlur={handleSave}
          onFocus={handleFocus}
          width="100%"
          value={value}
          rows="200"
          cacheMeasurements={false}
          onHeightChange={(height) => height}
        />
      </div>
      <Flex
        mt={['0.313rem']}
        textAlign="right"
        style={{
          display: focused ? 'block' : 'none',
        }}
      >
        <IconButton mr={['0.313rem']} onMouseDown={handleReset}>
          <CloseTask />
        </IconButton>
        <IconButton onMouseDown={handleSave}>
          <CheckTask />
        </IconButton>
      </Flex>
    </Flex>
  );
}

DefaultTextarea.propTypes = {
  handleChangeInput: PropTypes.func.isRequired,
  initalValue: PropTypes.string.isRequired,
};
